"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const tdcsInformCallTypeEnum = {
  'AUTH-ACCOUNT': 1,
  'AUTH-DEVICE': 2,
  'UNAUTH-DEVICE': 3
};
var _default = tdcsInformCallTypeEnum;
exports.default = _default;